import { CREDENTIAL_LABEL, CREDENTIAL_LABEL_SHORT, issuesCredential } from "@repo/shared";

import type { CredentialType, IssuableCredentialType } from "@repo/shared";
import type { GetAllCertificatesResponse } from "~/api/generated-api";

/**
 * La credencial tal como la devuelve la API. Se deriva del cliente generado en vez de
 * redeclararse a mano porque la copia manual se desincronizó: le faltaban `code`, `type` e
 * `issuedAt`, y el front terminaba mostrando `undefined` en una pantalla que la persona
 * comparte con un empleador. Derivándola, el próximo cambio de contrato rompe en compilación.
 */
export type CertificateType = GetAllCertificatesResponse["data"][number];

/**
 * `CREDENTIAL_LABEL` sólo tiene rótulo para los tipos emitibles, pero el `type` que viaja por
 * la API incluye `none`. Una credencial ya emitida no debería serlo nunca —el tipo se congela
 * al emitir—, así que si igual llega, se prefiere un rótulo neutro antes que imprimir
 * `undefined` en la tarjeta.
 */
export const credentialLabel = (type: CredentialType | null | undefined): string =>
  issuesCredential(type) ? CREDENTIAL_LABEL[type as IssuableCredentialType] : "Credencial";

/** Igual que `credentialLabel`, pero en minúscula para meterlo dentro de una frase. */
export const credentialLabelShort = (type: CredentialType | null | undefined): string =>
  issuesCredential(type) ? CREDENTIAL_LABEL_SHORT[type as IssuableCredentialType] : "credencial";

/** La página pública donde cualquiera puede verificar esta credencial. */
export const credentialPublicPath = (code: string) => `/certificado/${code}`;
